<script>
  export let scale = 1;
  export let color = "#323232";
</script>

<svg width={64 * scale} height={64 * scale} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path fill={color} d="M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h8zm-1 2h-6v4h6v-4zM6.707 6.293l2.25 2.25L11 6.5V12H5.5l2.043-2.043-2.25-2.25 1.414-1.414z" />
</svg>
